import { Component, OnInit, OnChanges, Input, Output, EventEmitter, OnDestroy, Inject, ViewChild } from '@angular/core';
import { Observable, Subscription, of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { map } from 'rxjs/operators';
import { APP_CONFIG } from '../../../../../src/app/config/app-config.module';

import {
  IApproveIdentityDocsRequest,
  IApproveUploadedDocsParams,
  IRejectDocumentRequest,
  IRejectIdentityDocsRequest,
  RejectReason
} from '../../../features/employee-detail/models/approve-document.model';
import { loadDownloadFile } from '../../../static-data/actions';
import { IDownloadFileRequest } from '../../../static-data/models/download-file.model';
import { fromApproveActions } from '../../../../app/features/employee-detail/actions';
import { IRejectionReason } from '../../../../../src/app/static-data/models/rejection-reason.model';
import { saveUploadedFileToStore, loadGetUploadedDocs } from '../../../../app/features/employee-detail/actions/get-uploaded-doc.actions';
import { fromOpenFileSelector } from '../../../features/employee-detail/selectors';
import { IUploadDocsParams } from '../../../features/employee-detail/models/IUploadDocsParams.model';
import { fromSelectedBusinessSelector } from '../../../features/businesses/selectors';
import { HelpersService } from '../../../../../src/app/core/services/helpers.service';
import { fromStaticDataRejectionReasonSelector } from '../../../static-data/selectors';
import { IGovIdProof } from '../../../../../src/app/features/employee-detail/models/govId.model';
import {
  getPreviousProofOfGovIds
} from '../../../features/employee-detail/selectors';
import { AngularFireAnalytics } from '@angular/fire/compat/analytics';
import { AppConfig } from '../../../../../src/app/core/config-models/app-config.model';
import { IHomeAddressResponse } from '../../../../../src/app/features/employee-detail/models/home-address.model';
import { fromGovIdProofActions } from '../../../features/employee-detail/actions';
import { DxFileUploaderComponent } from 'devextreme-angular';
import {
  hasNonBlankEmployeeRejectionMessage,
  hasRejectionReasonSelection
} from 'src/app/shared/utils/document-rejection-form.util';

@Component({
  selector: 'app-identity-doc-validation',
  templateUrl: './identity-doc-validation.component.html',
  styleUrls: ['./identity-doc-validation.component.css']
})
export class IdentityDocValidationComponent implements OnInit, OnDestroy {
  @ViewChild('fubauto', { static: false }) fileUploader: DxFileUploaderComponent;
  approveUploadedDocParams: IApproveUploadedDocsParams;

  @Input() currentImageData: any;
  @Input() imagesForPrevious: any;
  @Input() showFicaBtn: boolean = false;
  @Input() showUploadBtn: boolean = false;

  loadPreviousProofOfGovIdData$: Observable<IGovIdProof[]>;

  videoFile: any;
  video: boolean;

  currentImages: any[] = [];
  previousImages: any[] = [];

  currentImage: string;
  imageClicked: boolean;
  setBigImage: string;
  staticdDataRejectReasonsObs$: Observable<any>;
  rejectUploadedDocParams: '';
  rejectUploadedDocRequest: '';
  rejectUploadedDocObs$: Observable<any>;
  rejectUploadedDocSubs: Subscription = new Subscription();
  getCurrentPicObs$: Observable<any>;
  getCurrentPicSubs: Subscription = new Subscription();
  openPic: boolean;
  rejectionReason: string;
  extraInfo: string;
  privatenote: string;
  testBase64: string;

  getUploadedFileStatus$: Observable<boolean>;
  getUploadedFileStatusSub: Subscription = new Subscription();
  displayRejectModal: boolean;
  fileID: string;
  userIdentityID: string;
  fileType: string;
  fileTypeId: string;
  reason: string;
  privateNotes: string;
  declineUploadedDocParams: IRejectDocumentRequest;
  option: IRejectionReason;
  rejectionReason$: Observable<IRejectionReason[]>;
  subscription: Subscription = new Subscription();
  chosen: string;
  businessId: string;
  displayUploadModal: boolean;
  fileNameFICA: string;
  uploadFICAURL: string;
  loadProofOfGovIdData$: Observable<IGovIdProof>;
  loadCurrentHomeAddressData$: Observable<IHomeAddressResponse>;
  selectedTabIndex:number = 0;
  tabsWithText:any[];
  headers: any;
  allRejectionReasons: any[];
  selectedRejectReason: any;
  rejectionSubmitAttempted = false;

  constructor(
    private store: Store,
    private helperService: HelpersService,
    private analytics: AngularFireAnalytics,
    @Inject(APP_CONFIG) private appConfig: AppConfig
  ) {
    this.rejectionReason$ = this.store.select(fromStaticDataRejectionReasonSelector.getStaticDataRejectionResponse);
    this.rejectionReason$.subscribe(response=>{
      this.allRejectionReasons = response;
    });
    this.tabsWithText = [
      {id:1, text:'Current'},
      {id:2, text:'Archived'}
    ];
  }

  ngOnInit() {
    this.displayRejectModal = false;
    this.displayUploadModal = false;

    this.subscription.add(
      this.store.select(fromSelectedBusinessSelector.getSelectedBusinesses).subscribe(data => {
        if (data != undefined) {
          this.businessId = data.id;
        }
      })
    );
    this.loadPreviousProofOfGovIdData$ = this.store.select(getPreviousProofOfGovIds);

    var bearerToken = sessionStorage.getItem('token');
    this.headers = { 'Authorization': `Bearer ${bearerToken}` };
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSelectionChanged(e){
    var index = e.addedItems[0].id - 1;
    this.selectedTabIndex = index;
  }

  openFileInBrowser(val) {
    const ext = val?.fileName?.match(/\.([a-zA-Z0-9]+)(?:\?|$)/)?.[1];
    const req: IDownloadFileRequest = {
      documentName: val.fileName,
      ...(ext && { imageType: ext })
    };
    this.store.dispatch(loadDownloadFile({ request: req }));
  }

  openFileInBrowser2(extension, newBase64Str) {
    var win;

    switch (true) {
      case extension === 'jpeg' ||
        extension === 'JPG' ||
        extension === 'png' ||
        extension === 'PNG' ||
        extension === 'txt' ||
        extension === 'JPEG' ||
        extension === 'jpg' ||
        extension === 'TXT' ||
        extension === 'tiff' ||
        extension === 'TIFF':
        win = window.open();

        let data = `data:image/${extension};base64,${newBase64Str}`;

        win.document.write(
          '<iframe src="' +
            data +
            '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>'
        );
        break;
      case extension === 'rtf':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/rtf;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'xml':
        win = window.open();
        win.document.write("<iframe width='100%' height='100%' src='data:text/xml;base64, " + encodeURI(newBase64Str) + "'></iframe>");
        break;
      case extension === 'pdf' || extension === 'PDF':
        win = window.open();
        win.document.write(
          "<iframe width='100%' height='100%' src='data:application/pdf;base64, " + encodeURI(newBase64Str) + "'></iframe>"
        );
        break;
      case extension === 'mp4' ||
        extension === 'm4v' ||
        extension === '3gp' ||
        extension === 'avi' ||
        extension === 'flv' ||
        extension === 'mkv' ||
        extension === 'mov' ||
        extension === 'mpeg' ||
        extension === 'mpg' ||
        extension === 'mts' ||
        extension === 'vob' ||
        extension === 'webm' ||
        extension === 'wmv':
        this.videoFile = `data:${extension};base64,${newBase64Str}`;
        this.video = true;
        break;
      default:
        break;
    }
  }


  get showRejectionReasonError(): boolean {
    return (
      this.rejectionSubmitAttempted &&
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option)
    );
  }

  get showEmployeeMessageError(): boolean {
    return this.rejectionSubmitAttempted && !hasNonBlankEmployeeRejectionMessage(this.reason);
  }

  saveRejectionReason() {
    this.rejectionSubmitAttempted = true;
    if (
      !hasRejectionReasonSelection(this.selectedRejectReason, this.option) ||
      !hasNonBlankEmployeeRejectionMessage(this.reason)
    ) {
      return;
    }
    this.rejectionSubmitAttempted = false;

    const rejectReason: RejectReason = {
      customerId: this.helperService.checkCustomerIdState(),
      adminPrivateNotes: this.privateNotes,
      extraInfo: this.reason,
      uploadedFileId: this.fileID,
      uploadedFileRejectReasonId: this.selectedRejectReason.id
    };

    const req: IRejectIdentityDocsRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      userIdentityId: this.userIdentityID,
      uploadedFileId: this.fileID,
      uploadedFileType: this.fileTypeId,
      rejectReason: rejectReason
    };

    this.store.dispatch(
      fromApproveActions.rejectDocumentRequest({
        request: req
      })
    );
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
  }

  /* #region  decline doc */
  declineDocument(uploadedFileId, userIdentityId, uploadedFileTypeDescription, uploadedFileTypeId) {
    this.displayRejectModal = true;
    this.fileID = uploadedFileId;
    this.userIdentityID = userIdentityId;
    this.fileType = uploadedFileTypeDescription;
    this.fileTypeId = uploadedFileTypeId;

    this.privateNotes = '';
    this.reason = '';
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
    this.option = {
      id: '',
      description: '',
      extraInfo: ''
    };
  }
  /* #endregion */

  close() {
    this.imageClicked = false;
    this.video = false;
  }

  imageApproveFunction(uploadedFileId, userIdentityId, uploadedFileTypeDescription, uploadedFileTypeId) {
    const req: IApproveIdentityDocsRequest = {
      customerId: this.helperService.checkCustomerIdState(),
      userIdentityId: userIdentityId,
      uploadedFileId: uploadedFileId,
      uploadedFileType: uploadedFileTypeId
    };

    this.store.dispatch(
      fromApproveActions.approveDocumentRequest({
        request: req
      })
    );
  }

  onImageStatus(val) {}

  onChangeTab($event) {}

  selected(e) {
    this.selectedRejectReason = this.allRejectionReasons.find(item => item.id === e.value);
    this.reason = this.selectedRejectReason?.extraInfo ?? '';
  }

  uploadDoc() {
    this.displayUploadModal = true;
  }

  delete() {}

  replaceFICADocument(file) {
    this.fileNameFICA = '';
    this.uploadFICAURL = '';
    if (file.uploadedFileTypeDescription === 'Identity') {
      let uploadedFileIdentityId = file.uploadedFileId;
      this.fileNameFICA = `Identity/${uploadedFileIdentityId}`;
      this.uploadFICAURL = `${this.appConfig.apiEndpoint}/CustomerAdmin/${this.helperService.checkCustomerIdState()}/Identity/${file.userIdentityId}/UploadedFile/${uploadedFileIdentityId}/Replace`;
    }
  }

  ficaDocUploadControl(val, fileUploader) {
    this.helperService.notifySuccess('Uploaded succesfully', 300, 3000);

    this.store.dispatch(
      fromGovIdProofActions.loadProofGovIds({
        request: this.helperService.checkCustomerIdState()
      })
    );

    this.fileUploader.instance.reset();
  }

  errorUploadedFICA(fileUploader, error) {
    this.helperService.handleGeneralErrors(false, 'Oops', `${error.error.status} - ${error.error.statusText}`);
    this.fileUploader.instance.reset();
  }

  closeRejectionPop(){
    this.displayRejectModal = false;
    this.selectedRejectReason = null;
    this.rejectionSubmitAttempted = false;
  }
}
